// Sentences built from numbers can't be translated word by word by the design's FR pairs;
// such texts pick their language here. The app sets <html lang> from the user's preference (applyLang).
export const isFr = () => typeof document !== 'undefined' && document.documentElement.lang === 'fr';
/** German or French text, by the current UI language. */
export const tr2 = (de: string, fr: string) => (isFr() ? fr : de);
